import api from './api';

export interface MasterData {
  activities: Record<string, number>;
  day_addon_activities: Record<string, number>;
  meals: Record<string, number>;
  tours: Record<number, any>;
  tours_name_id: Record<string, number>;
  tours_details?: Record<number, string>;
  vehicles: Record<string, number>;
  agencies: Record<string, number>;
  trip_types: Record<string, number>;
}

export const getAllMasterData = async (): Promise<MasterData> => {
  const response = await api.get<MasterData>('/master-data/all');
  return response.data;
};

export const getActivities = async (type: string = 'REGULAR'): Promise<Record<string, number>> => {
  const response = await api.get(`/master-data/activities?type=${type}`);
  return response.data;
};

export const getMeals = async (): Promise<Record<string, number>> => {
  const response = await api.get('/master-data/meals');
  return response.data;
};

export const getTours = async (): Promise<any> => {
  const response = await api.get('/master-data/tours');
  return response.data;
};

export const getVehicles = async (): Promise<Record<string, number>> => {
  const response = await api.get('/master-data/vehicles');
  return response.data;
};

export const getAgencies = async (): Promise<Record<string, number>> => {
  const response = await api.get('/master-data/agencies');
  return response.data;
};

export const getMasterData = async (): Promise<any> => {
  const response = await api.get('/master-data/all?clear_cache=true');
  //console.log('Raw API response:', response.data);
  
  const flattenIfNeeded = (obj: any, name: string) => {
    if (!obj || typeof obj !== 'object') return {};
    const flattened: Record<string, number> = {};
    Object.entries(obj).forEach(([key, value]: [string, any]) => {
      if (typeof value === 'number') {
        flattened[key] = value;
      } else if (typeof value === 'object' && value !== null && 'activity_id' in value) {
        flattened[key] = value.activity_id;
      } else if (typeof value === 'object' && value !== null && 'id' in value) {
        flattened[key] = value.id;
      }
    });
    return flattened;
  };
  
  const toursDetails: Record<number, string> = {};
  //console.log('tours from API:', response.data.tours);
  if (response.data.tours && typeof response.data.tours === 'object') {
    Object.entries(response.data.tours).forEach(([id, tour]: [string, any]) => {
      if (tour && tour.tour_description) {
        toursDetails[parseInt(id)] = tour.tour_description;
      }
    });
  }
  //console.log('Final toursDetails:', toursDetails);
  
  const activitiesDetails: Record<number, string> = {};
  if (response.data.activities && typeof response.data.activities === 'object') {
    Object.entries(response.data.activities).forEach(([name, activity]: [string, any]) => {
      if (activity && typeof activity === 'object' && activity.activity_id && activity.activity_description) {
        activitiesDetails[activity.activity_id] = activity.activity_description;
      }
    });
  }
  
  const result = {
    agencies: flattenIfNeeded(response.data.agencies, 'agencies'),
    vehicles: flattenIfNeeded(response.data.vehicles, 'vehicles'),
    activities: flattenIfNeeded(response.data.activities, 'activities'),
    activities_details: activitiesDetails,
    day_addon_activities: flattenIfNeeded(response.data.day_addon_activities, 'day_addon'),
    meals: flattenIfNeeded(response.data.meals, 'meals'),
    tours: flattenIfNeeded(response.data.tours_name_id, 'tours'),
    tours_details: toursDetails,
    trip_types: flattenIfNeeded(response.data.trip_types, 'trip_types'),
    hotel_categories: ['3 Star', '4 Star', '5 Star', '4* Pool Villa', '5* Pool Villa']
  };
  console.log('Final result:', result);
  return result;
};

export const masterDataService = {
  getAllMasterData,
  getActivities,
  getMeals,
  getTours,
  getVehicles,
  getAgencies,
  getMasterData
};
